import { ORGANIZATION_SEARCH } from './types';
import { Dispatch } from 'redux';

export const searchOrganization = (payload: unknown) => (dispatch: Dispatch): void => {
  dispatch({
    type: ORGANIZATION_SEARCH,
    payload
  });
};
